module.exports = __webpack_public_path__ + "static/media/chart-line.e1b5f8c0.svg";